import apiUrl from '../../../../../utils/settings';


export const GstUserPanDataFetchUrl = () => {
    return apiUrl + '/user-pan-and-gst/get-pan-details';
};
export const getAmountForMedicalInsuranceUrl = () => {
    return apiUrl + '/company-benefit-value/get';
};
export const GetAllUserInsuranceCertificateUrl = () => {
    return apiUrl + '/benefit-packages/get-user-certificate-image-by-company-id';
};
export const getBenefitsDataOfUserUrl = () => {
    return apiUrl + '/company-benefit-packages/get-benefit-details';
};
export const GetUserInsuranceCertificateUrl = () => {
    return apiUrl + '/benefit-packages/get-user-certificate-s3-image/';
};